/**
 * Client-side scoring utilities.
 * Full scoring pipeline runs server-side via the scoreOnMatchFinal Cloud Function.
 */

export const DEFAULT_POINTS_CONFIG = {
  group: 5,
  r32: 10,
  r16: 15,
  qf: 20,
  sf: 25,
  final: 50,
  third: 50,
};

export function getBasePoints(round, pointsConfig) {
  return (pointsConfig && pointsConfig[round] != null)
    ? pointsConfig[round]
    : DEFAULT_POINTS_CONFIG[round] ?? 0;
}

export function calculatePickAccuracy(correctPicks, totalPicks) {
  if (!totalPicks) return 0;
  return (correctPicks / totalPicks) * 100;
}

export function isEliminated(mpp, leaderPoints) {
  return mpp < leaderPoints;
}
